export default "__VITE_ASSET__CHI5ZKsA__"